import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
export function template() {
  return /* @__PURE__ */ jsx("div", { attrs: {
    role: "button"
  }, class: {
    "create-annotations-button-container": true,
    active: this.isAttributeEnabled("active")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TooltipEl, { placement: Placement.Top, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, "Add Annotation"), /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "plus"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }));
}
